import { useState } from 'react';
import { BarChart2, Settings, RefreshCw, Activity } from 'lucide-react';
import AnalyticsDashboard from '../sales-components/AnalyticsDashboard';

const AnalyticsSalesDashboard = () => {

  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleRefresh = () => {
    setLoading(true);
    setRefreshKey(k => k + 1);
    setTimeout(() => setLoading(false), 500);
  };

  return (

    <div className="min-h-screen bg-slate-50">
      {/*
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-sm">
        <div className="flex items-center justify-between px-5 py-3 max-w-screen-2xl mx-auto">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 shadow-sm shadow-indigo-200">
              <BarChart2 className="h-4 w-4 text-white" />
            </div>
            <div>
              <h1 className="text-sm font-bold text-slate-800">Sales Analytics Dashboard</h1>
              <p className="text-[10px] text-slate-400">
                analyticssalesdashboards · Live data
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={handleRefresh}
              disabled={loading}
              className="flex items-center gap-1.5 rounded-lg bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-indigo-700 transition-colors disabled:opacity-60 shadow-sm"
            >
              <RefreshCw className={`h-3.5 w-3.5 ${loading ? 'animate-spin' : ''}`} />
              Refresh All
            </button>
          </div>
        </div>
      </header>
      */ }
      {/* ── Dashboard ── */}
      <div className="max-w-screen-2xl mx-auto">
        <AnalyticsDashboard key={refreshKey} onRefresh={handleRefresh} loading={loading}/>
      </div>            
    </div>
  );
};

export default AnalyticsSalesDashboard;